import "./style.scss";
import warningModalIcon from "../../assets/images/warning_modal.svg";
import { Button } from "antd";

const WarningModal = ({ isOpen, onClose, text, onOK }) => {
  return (
    isOpen && (
      <div className="warning-modal-overlay" onClick={onClose}>
        <div className="warning_modal_wrapper">
          <div className="warning_modal_container_top">
            <div className="warning_icon">
              <img src={warningModalIcon} alt="warningModalIcon" />
            </div>
          </div>
          <div
            className="warning-modal-container"
            onClick={(e) => e.stopPropagation()}
          >
            <div className="warning_modal_container_bottom">
              <h1>Warning !</h1>
              <div className="warning_modal_content">
                <p>{text}</p>
              </div>
              <div className="warning_modal_btn">
                <Button
                  onClick={onClose}
                  //   style={{ border: "1px solid yellow" }}
                >
                  Skip
                </Button>
                <Button onClick={onOK}>OK</Button>
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  );
};

export default WarningModal;
